import { Action, TenantSubject } from '@area-restrita/shared/authorization';

export interface PermissionCategory {
  category: string;
  subCategories: {
    subCategory: string;
    rules: {
      action: Action;
      subject: TenantSubject;
      label: string;
      description: string;
      category: string;
    }[];
  }[];
}

export const permissionCategories: PermissionCategory[] = [
  {
    category: 'Empresas',
    subCategories: [
      {
        subCategory: 'Empresas',
        rules: [
          {
            action: 'list',
            subject: 'companies',
            label: 'Listar empresas',
            description: 'Permite visualizar a lista de empresas',
            category: 'Empresas',
          },
          {
            action: 'viewDetails',
            subject: 'companies',
            label: 'Ver detalhes de empresas',
            description: 'Permite visualizar detalhes completos de empresas',
            category: 'Empresas',
          },
          {
            action: 'create',
            subject: 'companies',
            label: 'Criar empresas',
            description: 'Permite criar novas empresas',
            category: 'Empresas',
          },
          {
            action: 'update',
            subject: 'companies',
            label: 'Atualizar empresas',
            description: 'Permite editar empresas existentes',
            category: 'Empresas',
          },
          {
            action: 'delete',
            subject: 'companies',
            label: 'Excluir empresas',
            description: 'Permite remover empresas do sistema',
            category: 'Empresas',
          },
        ],
      },
      {
        subCategory: 'Associações de Empresas',
        rules: [
          // Associações de empresas
          {
            action: 'list',
            subject: 'company_memberships',
            label: 'Listar associações de empresas',
            description:
              'Permite visualizar associações entre usuários e empresas',
            category: 'Associações de Empresas',
          },
          {
            action: 'create',
            subject: 'company_memberships',
            label: 'Criar associações de empresas',
            description:
              'Permite criar novas associações entre usuários e empresas',
            category: 'Associações de Empresas',
          },
          {
            action: 'update',
            subject: 'company_memberships',
            label: 'Atualizar associações de empresas',
            description: 'Permite editar associações entre usuários e empresas',
            category: 'Associações de Empresas',
          },
        ],
      },
    ],
  },
  {
    category: 'Documentos',
    subCategories: [
      {
        subCategory: 'Categorias de Documentos',
        rules: [
          {
            action: 'list',
            subject: 'document_categories',
            label: 'Listar categorias de documentos',
            description:
              'Permite visualizar a lista de categorias de documentos',
            category: 'Categorias de Documentos',
          },
          {
            action: 'viewDetails',
            subject: 'document_categories',
            label: 'Ver detalhes de categorias',
            description:
              'Permite visualizar detalhes de categorias de documentos',
            category: 'Categorias de Documentos',
          },
          {
            action: 'create',
            subject: 'document_categories',
            label: 'Criar categorias',
            description: 'Permite criar novas categorias de documentos',
            category: 'Categorias de Documentos',
          },
          {
            action: 'update',
            subject: 'document_categories',
            label: 'Atualizar categorias',
            description: 'Permite editar categorias de documentos existentes',
            category: 'Categorias de Documentos',
          },
          {
            action: 'delete',
            subject: 'document_categories',
            label: 'Excluir categorias',
            description: 'Permite remover categorias de documentos',
            category: 'Categorias de Documentos',
          },
        ],
      },
      {
        subCategory: 'Documentos',
        rules: [
          {
            action: 'list',
            subject: 'documents',
            label: 'Listar documentos',
            description: 'Permite visualizar a lista de documentos',
            category: 'Documentos',
          },
          {
            action: 'viewDetails',
            subject: 'documents',
            label: 'Ver detalhes de documentos',
            description: 'Permite visualizar detalhes completos de documentos',
            category: 'Documentos',
          },
          {
            action: 'create',
            subject: 'documents',
            label: 'Criar documentos',
            description: 'Permite criar novos documentos',
            category: 'Documentos',
          },
          {
            action: 'update',
            subject: 'documents',
            label: 'Atualizar documentos',
            description: 'Permite editar documentos existentes',
            category: 'Documentos',
          },
          {
            action: 'update',
            subject: 'document_permissions',
            label: 'Gerenciar permissões de documentos',
            description: 'Permite configurar permissões de acesso a documentos',
            category: 'Documentos',
          },
          {
            action: 'delete',
            subject: 'documents',
            label: 'Excluir documentos',
            description: 'Permite remover documentos do sistema',
            category: 'Documentos',
          },
        ],
      },
      {
        subCategory: 'Solicitações de Documentos',
        rules: [
          {
            action: 'list',
            subject: 'document_requests',
            label: 'Listar solicitações de documentos',
            description:
              'Permite visualizar a lista de solicitações de documentos',
            category: 'Solicitações de Documentos',
          },
          {
            action: 'viewDetails',
            subject: 'document_requests',
            label: 'Ver detalhes de solicitações',
            description:
              'Permite visualizar detalhes de solicitações de documentos',
            category: 'Solicitações de Documentos',
          },
          {
            action: 'create',
            subject: 'document_requests',
            label: 'Criar solicitações',
            description: 'Permite criar novas solicitações de documentos',
            category: 'Solicitações de Documentos',
          },
          {
            action: 'update',
            subject: 'document_requests',
            label: 'Atualizar solicitações',
            description: 'Permite editar solicitações de documentos existentes',
            category: 'Solicitações de Documentos',
          },
          {
            action: 'delete',
            subject: 'document_requests',
            label: 'Excluir solicitações',
            description: 'Permite remover solicitações de documentos',
            category: 'Solicitações de Documentos',
          },
        ],
      },
    ],
  },
  {
    category: 'Rotas',
    subCategories: [
      {
        subCategory: 'Linhas de Ônibus',
        rules: [
          {
            action: 'list',
            subject: 'buslines',
            label: 'Listar linhas de ônibus',
            description: 'Permite visualizar a lista de linhas de ônibus',
            category: 'Linhas de Ônibus',
          },
          {
            action: 'viewDetails',
            subject: 'buslines',
            label: 'Ver detalhes de linhas',
            description: 'Permite visualizar detalhes de linhas de ônibus',
            category: 'Linhas de Ônibus',
          },
          {
            action: 'create',
            subject: 'buslines',
            label: 'Criar linhas',
            description: 'Permite criar novas linhas de ônibus',
            category: 'Linhas de Ônibus',
          },
          {
            action: 'update',
            subject: 'buslines',
            label: 'Atualizar linhas',
            description: 'Permite editar linhas de ônibus existentes',
            category: 'Linhas de Ônibus',
          },
          {
            action: 'delete',
            subject: 'buslines',
            label: 'Excluir linhas',
            description: 'Permite remover linhas de ônibus',
            category: 'Linhas de Ônibus',
          },
        ],
      },
    ],
  },

  {
    category: 'Execução de Rota',
    subCategories: [
      {
        subCategory: 'Checklists',
        rules: [
          {
            action: 'list',
            subject: 'checklists',
            label: 'Listar checklists',
            description: 'Permite visualizar a lista de checklists',
            category: 'Checklists',
          },
          {
            action: 'viewDetails',
            subject: 'checklists',
            label: 'Ver detalhes de checklists',
            description: 'Permite visualizar detalhes de checklists',
            category: 'Checklists',
          },
          {
            action: 'create',
            subject: 'checklists',
            label: 'Criar checklists',
            description: 'Permite criar novos checklists',
            category: 'Checklists',
          },
          {
            action: 'update',
            subject: 'checklists',
            label: 'Atualizar checklists',
            description: 'Permite editar checklists existentes',
            category: 'Checklists',
          },
          {
            action: 'delete',
            subject: 'checklists',
            label: 'Excluir checklists',
            description: 'Permite remover checklists',
            category: 'Checklists',
          },
        ],
      },
      {
        subCategory: 'Execuções de Rota',
        rules: [
          {
            action: 'list',
            subject: 'actings',
            label: 'Listar execuções de rota',
            description: 'Permite visualizar a lista de execuções de rota',
            category: 'Execuções de Rota',
          },
          {
            action: 'viewDetails',
            subject: 'actings',
            label: 'Ver detalhes de execuções de rota',
            description: 'Permite visualizar detalhes de execuções de rota',
            category: 'Execuções de Rota',
          },
          {
            action: 'create',
            subject: 'actings',
            label: 'Iniciar execuções de rota',
            description: 'Permite iniciar novas execuções de rota',
            category: 'Execuções de Rota',
          },
          {
            action: 'update',
            subject: 'actings',
            label: 'Atualizar execuções de rota',
            description: 'Permite editar execuções de rota existentes',
            category: 'Execuções de Rota',
          },
          {
            action: 'abort',
            subject: 'actings',
            label: 'Abortar execuções',
            description: 'Permite encerrar execuções de rota em andamento',
            category: 'Execuções de Rota',
          },
          {
            action: 'delete',
            subject: 'actings',
            label: 'Excluir execuções de rota',
            description: 'Permite remover execuções de rota',
            category: 'Execuções de Rota',
          },
        ],
      },
    ],
  },
  {
    category: 'Frotas',
    subCategories: [
      {
        subCategory: 'Frotas',
        rules: [
          {
            action: 'list',
            subject: 'fleets',
            label: 'Listar frotas',
            description: 'Permite visualizar a lista de frotas',
            category: 'Frotas',
          },
          {
            action: 'create',
            subject: 'fleets',
            label: 'Criar frotas',
            description: 'Permite criar novas frotas',
            category: 'Frotas',
          },
          {
            action: 'update',
            subject: 'fleets',
            label: 'Atualizar frotas',
            description: 'Permite editar frotas existentes',
            category: 'Frotas',
          },
          {
            action: 'delete',
            subject: 'fleets',
            label: 'Excluir frotas',
            description: 'Permite remover frotas',
            category: 'Frotas',
          },
        ],
      },
    ],
  },
  {
    category: 'NPS',
    subCategories: [
      {
        subCategory: 'Campanhas NPS',
        rules: [
          {
            action: 'list',
            subject: 'nps',
            label: 'Listar campanhas NPS',
            description: 'Permite visualizar a lista de campanhas NPS',
            category: 'Campanhas NPS',
          },
          {
            action: 'viewDetails',
            subject: 'nps',
            label: 'Ver detalhes de campanhas NPS',
            description:
              'Permite visualizar detalhes e métricas de campanhas NPS',
            category: 'Campanhas NPS',
          },
          {
            action: 'create',
            subject: 'nps',
            label: 'Criar campanhas NPS',
            description: 'Permite criar novas campanhas NPS',
            category: 'Campanhas NPS',
          },
          {
            action: 'update',
            subject: 'nps',
            label: 'Editar rascunhos NPS',
            description: 'Permite editar campanhas NPS em rascunho',
            category: 'Campanhas NPS',
          },
          {
            action: 'delete',
            subject: 'nps',
            label: 'Excluir rascunhos NPS',
            description: 'Permite excluir campanhas NPS em rascunho',
            category: 'Campanhas NPS',
          },
          {
            action: 'open',
            subject: 'nps',
            label: 'Abrir campanhas NPS',
            description: 'Permite abrir campanhas NPS para respostas',
            category: 'Campanhas NPS',
          },
          {
            action: 'close',
            subject: 'nps',
            label: 'Encerrar campanhas NPS',
            description: 'Permite encerrar campanhas NPS abertas',
            category: 'Campanhas NPS',
          },
          {
            action: 'viewComments',
            subject: 'nps',
            label: 'Visualizar comentários NPS',
            description:
              'Permite visualizar comentários enviados em campanhas NPS',
            category: 'Campanhas NPS',
          },
          {
            action: 'export',
            subject: 'nps',
            label: 'Exportar resultados NPS',
            description: 'Permite exportar resultados de campanhas NPS',
            category: 'Campanhas NPS',
          },
        ],
      },
    ],
  },
  {
    category: 'Configurações',
    subCategories: [
      {
        subCategory: 'Departamentos',
        rules: [
          {
            action: 'list',
            subject: 'departments',
            label: 'Listar departamentos',
            description: 'Permite visualizar a lista de departamentos',
            category: 'Departamentos',
          },
          {
            action: 'viewDetails',
            subject: 'departments',
            label: 'Ver detalhes de departamentos',
            description: 'Permite visualizar detalhes de departamentos',
            category: 'Departamentos',
          },
          {
            action: 'create',
            subject: 'departments',
            label: 'Criar departamentos',
            description: 'Permite criar novos departamentos',
            category: 'Departamentos',
          },
          {
            action: 'update',
            subject: 'departments',
            label: 'Atualizar departamentos',
            description: 'Permite editar departamentos existentes',
            category: 'Departamentos',
          },
          {
            action: 'delete',
            subject: 'departments',
            label: 'Excluir departamentos',
            description: 'Permite remover departamentos',
            category: 'Departamentos',
          },
        ],
      },
      {
        subCategory: 'Funções e Cargos',
        rules: [
          {
            action: 'list',
            subject: 'roles',
            label: 'Listar funções',
            description: 'Permite visualizar a lista de funções/cargos',
            category: 'Funções e Cargos',
          },
          {
            action: 'viewDetails',
            subject: 'roles',
            label: 'Ver detalhes de funções',
            description: 'Permite visualizar detalhes de funções/cargos',
            category: 'Funções e Cargos',
          },
          {
            action: 'create',
            subject: 'roles',
            label: 'Criar funções',
            description: 'Permite criar novas funções/cargos',
            category: 'Funções e Cargos',
          },
          {
            action: 'update',
            subject: 'roles',
            label: 'Atualizar funções',
            description: 'Permite editar funções/cargos existentes',
            category: 'Funções e Cargos',
          },
          {
            action: 'delete',
            subject: 'roles',
            label: 'Excluir funções',
            description: 'Permite remover funções/cargos',
            category: 'Funções e Cargos',
          },
        ],
      },
      {
        subCategory: 'Membros',
        rules: [
          {
            action: 'list',
            subject: 'memberships',
            label: 'Listar membros',
            description: 'Permite visualizar a lista de membros',
            category: 'Membros',
          },
          {
            action: 'viewDetails',
            subject: 'memberships',
            label: 'Ver detalhes de membros',
            description: 'Permite visualizar detalhes de membros',
            category: 'Membros',
          },
          {
            action: 'create',
            subject: 'memberships',
            label: 'Convidar membros',
            description: 'Permite convidar novos membros',
            category: 'Membros',
          },
          {
            action: 'update',
            subject: 'memberships',
            label: 'Atualizar membros',
            description: 'Permite editar membros existentes',
            category: 'Membros',
          },
          {
            action: 'delete',
            subject: 'memberships',
            label: 'Excluir membros',
            description: 'Permite remover membros',
            category: 'Membros',
          },
        ],
      },
    ],
  },
];

// export const permissionRules: PermissionRule[] = [
// Categorias de documentos
// Documentos
// Solicitações de documentos
// Empresas
// Linhas de ônibus
// // Horários de linhas
// {
//   action: 'list',
//   subject: 'busline_schedules',
//   label: 'Listar horários',
//   description: 'Permite visualizar a lista de horários de linhas',
//   category: 'Horários de Linhas',
// },
// {
//   action: 'viewDetails',
//   subject: 'busline_schedules',
//   label: 'Ver detalhes de horários',
//   description: 'Permite visualizar detalhes de horários de linhas',
//   category: 'Horários de Linhas',
// },
// {
//   action: 'update',
//   subject: 'busline_schedules',
//   label: 'Atualizar horários',
//   description: 'Permite editar horários de linhas existentes',
//   category: 'Horários de Linhas',
// },
// Departamentos
// Funções/Cargos
// Associações
// Atuações
// Checklists
// // Tenants
// {
//   action: 'list',
//   subject: 'tenants',
//   label: 'Listar inquilinos',
//   description: 'Permite visualizar a lista de inquilinos/tenants',
//   category: 'Tenants',
// },
// {
//   action: 'viewDetails',
//   subject: 'tenants',
//   label: 'Ver detalhes de inquilinos',
//   description: 'Permite visualizar detalhes de inquilinos/tenants',
//   category: 'Tenants',
// },
// {
//   action: 'create',
//   subject: 'tenants',
//   label: 'Criar inquilinos',
//   description: 'Permite criar novos inquilinos/tenants',
//   category: 'Tenants',
// },
// {
//   action: 'update',
//   subject: 'tenants',
//   label: 'Atualizar inquilinos',
//   description: 'Permite editar inquilinos/tenants existentes',
//   category: 'Tenants',
// },
// {
//   action: 'delete',
//   subject: 'tenants',
//   label: 'Excluir inquilinos',
//   description: 'Permite remover inquilinos/tenants',
//   category: 'Tenants',
// },
// Frotas
// ];
